import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTop.vue?vue&type=style&index=0&id=71973df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71973df4"]])

export default __exports__